var exports = {
  "Og": "ChannelMessages.module__messagesWrapper___bHI1a0",
  "gs": "ChannelMessages.module__scrollerContainer___bHI1a0",
  "aE": "ChannelMessages.module__bottomFade___bHI1a0",
  "yY": "ChannelMessages.module__bottomFadeStatusAtBottom___bHI1a0",
  "K9": "ChannelMessages.module__bottomFadeStatusScrolled___bHI1a0",
  "gT": "ChannelMessages.module__scrollerContent___bHI1a0",
  "lB": "ChannelMessages.module__scrollerSpacer___bHI1a0",
  "xo": "ChannelMessages.module__scrollerSpacerAfterFiller___bHI1a0",
  "pi": "ChannelMessages.module__fillerBuffer___bHI1a0",
  "CU": "ChannelMessages.module__groupSpacer___bHI1a0",
  "$P": "ChannelMessages.module__groupSpacerHalf___bHI1a0",
  "bv": "ChannelMessages.module__scrollerInner___bHI1a0",
  "eb": "ChannelMessages.module__newMessagesBar___bHI1a0",
  "mC": "ChannelMessages.module__newMessagesBarBanner___bHI1a0",
  "xp": "ChannelMessages.module__newMessagesBarBannerText___bHI1a0",
  "su": "ChannelMessages.module__newMessagesBarBannerAction___bHI1a0",
  "G6": "ChannelMessages.module__messageBottomPill___bHI1a0",
  "Sg": "ChannelMessages.module__jumpToPresentBar___bHI1a0",
  "RQ": "ChannelMessages.module__newMessagesBarText___bHI1a0",
  "As": "ChannelMessages.module__loadErrorBar___bHI1a0",
  "Ku": "ChannelMessages.module__newMessagesBarAction___bHI1a0",
  "WB": "ChannelMessages.module__unreadSlot___bHI1a0",
};

module.exports = exports;
